import { __decorate, __metadata } from "tslib";
import { IsNotEmptyObjectWithLVS, IsUndefinable, LengthWithLVS } from '@goparrot/common';
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsDefined, IsEnum, IsOptional, IsString, ValidateNested } from 'class-validator';
import { DefaultStoreExposeGroup, StoreSpecificTypeEnum, StoreTargetEnum } from '../interface';
import { PatchDefaultStoreContactInfoDto } from './PatchDefaultStoreContactInfoDto';
import { PatchDefaultStoreCountryDto } from './PatchDefaultStoreCountryDto';
import { PatchDefaultStoreDeliveryDto } from './PatchDefaultStoreDeliveryDto';
import { PatchDefaultStoreFeaturesFlagsDto } from './PatchDefaultStoreFeaturesFlagsDto';
import { PatchDefaultStoreMailerDto } from './PatchDefaultStoreMailerDto';
import { PatchDefaultStoreOrderDto } from './PatchDefaultStoreOrderDto';
import { PatchDefaultStoreOrderValidationDto } from './PatchDefaultStoreOrderValidationDto';
import { PatchDefaultStorePaymentDto } from './PatchDefaultStorePaymentDto';
import { PatchDefaultStorePickupDto } from './PatchDefaultStorePickupDto';
import { PatchDefaultStoreScheduleDto } from './PatchDefaultStoreScheduleDto';
let PatchDefaultStoreDto = class PatchDefaultStoreDto {
    constructor() {
        this.specificType = StoreSpecificTypeEnum.REGULAR;
    }
};
__decorate([
    ApiPropertyOptional({ type: () => String, minLength: 3, maxLength: 50, example: 'Merchant GoParrot' }),
    Expose({
        groups: [
            DefaultStoreExposeGroup.MODEL,
            DefaultStoreExposeGroup.READ,
            DefaultStoreExposeGroup.CREATE,
            DefaultStoreExposeGroup.UPDATE,
            DefaultStoreExposeGroup.PATCH,
            DefaultStoreExposeGroup.BASE_PATCH,
        ],
    }),
    IsOptional({ groups: [DefaultStoreExposeGroup.PATCH, DefaultStoreExposeGroup.BASE_PATCH] }),
    IsString({ groups: [DefaultStoreExposeGroup.CREATE, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH, DefaultStoreExposeGroup.BASE_PATCH] }),
    LengthWithLVS(3, 50, {
        groups: [DefaultStoreExposeGroup.CREATE, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH, DefaultStoreExposeGroup.BASE_PATCH],
    }),
    __metadata("design:type", String)
], PatchDefaultStoreDto.prototype, "title", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, minLength: 3, maxLength: 250, example: 'Merchant GoParrot Description' }),
    Expose({
        groups: [
            DefaultStoreExposeGroup.MODEL,
            DefaultStoreExposeGroup.READ,
            DefaultStoreExposeGroup.CREATE,
            DefaultStoreExposeGroup.UPDATE,
            DefaultStoreExposeGroup.PATCH,
            DefaultStoreExposeGroup.BASE_PATCH,
        ],
    }),
    IsOptional({ groups: [DefaultStoreExposeGroup.PATCH, DefaultStoreExposeGroup.BASE_PATCH] }),
    IsString({ groups: [DefaultStoreExposeGroup.CREATE, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH, DefaultStoreExposeGroup.BASE_PATCH] }),
    LengthWithLVS(3, 50, {
        groups: [DefaultStoreExposeGroup.CREATE, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH, DefaultStoreExposeGroup.BASE_PATCH],
    }),
    __metadata("design:type", String)
], PatchDefaultStoreDto.prototype, "subtitle", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, minLength: 3, maxLength: 50 }),
    Expose({
        groups: [
            DefaultStoreExposeGroup.MODEL,
            DefaultStoreExposeGroup.READ,
            DefaultStoreExposeGroup.CREATE,
            DefaultStoreExposeGroup.UPDATE,
            DefaultStoreExposeGroup.PATCH,
        ],
    }),
    IsOptional({ groups: [DefaultStoreExposeGroup.PATCH] }),
    IsString({ groups: [DefaultStoreExposeGroup.CREATE, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    LengthWithLVS(3, 50, { groups: [DefaultStoreExposeGroup.CREATE, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], PatchDefaultStoreDto.prototype, "shortName", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, minLength: 3, maxLength: 50 }),
    Expose({
        groups: [
            DefaultStoreExposeGroup.MODEL,
            DefaultStoreExposeGroup.READ,
            DefaultStoreExposeGroup.CREATE,
            DefaultStoreExposeGroup.UPDATE,
            DefaultStoreExposeGroup.PATCH,
        ],
    }),
    IsOptional({ groups: [DefaultStoreExposeGroup.PATCH] }),
    IsString({ groups: [DefaultStoreExposeGroup.CREATE, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    LengthWithLVS(3, 50, { groups: [DefaultStoreExposeGroup.CREATE, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], PatchDefaultStoreDto.prototype, "name", void 0);
__decorate([
    ApiPropertyOptional({ enum: DefaultStoreExposeGroup, default: StoreSpecificTypeEnum.REGULAR }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.CREATE, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.PATCH] }),
    IsUndefinable({ groups: [DefaultStoreExposeGroup.CREATE, DefaultStoreExposeGroup.PATCH] }),
    IsEnum(StoreSpecificTypeEnum, { always: true }),
    __metadata("design:type", String)
], PatchDefaultStoreDto.prototype, "specificType", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.CREATE, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.PATCH] }),
    IsUndefinable({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { groups: [DefaultStoreExposeGroup.CREATE, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], PatchDefaultStoreDto.prototype, "specificCustomType", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchDefaultStoreContactInfoDto }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.PATCH] }),
    IsDefined({ groups: [DefaultStoreExposeGroup.UPDATE] }),
    ValidateNested({ groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    Type(() => PatchDefaultStoreContactInfoDto),
    __metadata("design:type", PatchDefaultStoreContactInfoDto)
], PatchDefaultStoreDto.prototype, "contactInfo", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchDefaultStoreCountryDto }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.PATCH] }),
    ValidateNested({ groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    Type(() => PatchDefaultStoreCountryDto),
    __metadata("design:type", PatchDefaultStoreCountryDto)
], PatchDefaultStoreDto.prototype, "country", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchDefaultStoreDeliveryDto }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.PATCH] }),
    ValidateNested({ groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    Type(() => PatchDefaultStoreDeliveryDto),
    __metadata("design:type", PatchDefaultStoreDeliveryDto)
], PatchDefaultStoreDto.prototype, "delivery", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchDefaultStoreFeaturesFlagsDto }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.PATCH] }),
    IsDefined({ groups: [DefaultStoreExposeGroup.UPDATE] }),
    ValidateNested({ groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    Type(() => PatchDefaultStoreFeaturesFlagsDto),
    __metadata("design:type", PatchDefaultStoreFeaturesFlagsDto)
], PatchDefaultStoreDto.prototype, "featuresFlags", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchDefaultStoreMailerDto }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.PATCH] }),
    IsDefined({ groups: [DefaultStoreExposeGroup.UPDATE] }),
    ValidateNested({ groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    Type(() => PatchDefaultStoreMailerDto),
    __metadata("design:type", PatchDefaultStoreMailerDto)
], PatchDefaultStoreDto.prototype, "mailer", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchDefaultStoreOrderDto }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.PATCH] }),
    ValidateNested({ groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    Type(() => PatchDefaultStoreOrderDto),
    __metadata("design:type", PatchDefaultStoreOrderDto)
], PatchDefaultStoreDto.prototype, "order", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchDefaultStorePaymentDto }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.PATCH] }),
    ValidateNested({ groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    Type(() => PatchDefaultStorePaymentDto),
    __metadata("design:type", PatchDefaultStorePaymentDto)
], PatchDefaultStoreDto.prototype, "payment", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchDefaultStorePickupDto }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.PATCH] }),
    ValidateNested({ groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    Type(() => PatchDefaultStorePickupDto),
    __metadata("design:type", PatchDefaultStorePickupDto)
], PatchDefaultStoreDto.prototype, "pickup", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchDefaultStoreScheduleDto }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.PATCH] }),
    ValidateNested({ groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    Type(() => PatchDefaultStoreScheduleDto),
    __metadata("design:type", PatchDefaultStoreScheduleDto)
], PatchDefaultStoreDto.prototype, "schedule", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsNotEmptyObjectWithLVS({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.PATCH] }),
    __metadata("design:type", Object)
], PatchDefaultStoreDto.prototype, "diningOptionsConfig", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchDefaultStoreOrderValidationDto }),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.PATCH] }),
    ValidateNested({ groups: [DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    Type(() => PatchDefaultStoreOrderValidationDto),
    __metadata("design:type", PatchDefaultStoreOrderValidationDto)
], PatchDefaultStoreDto.prototype, "orderValidation", void 0);
__decorate([
    ApiPropertyOptional(),
    Expose({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsOptional({ groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH] }),
    IsEnum(StoreTargetEnum, {
        groups: [DefaultStoreExposeGroup.MODEL, DefaultStoreExposeGroup.READ, DefaultStoreExposeGroup.UPDATE, DefaultStoreExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], PatchDefaultStoreDto.prototype, "targetType", void 0);
PatchDefaultStoreDto = __decorate([
    Expose({
        groups: [
            DefaultStoreExposeGroup.MODEL,
            DefaultStoreExposeGroup.READ,
            DefaultStoreExposeGroup.CREATE,
            DefaultStoreExposeGroup.PATCH,
            DefaultStoreExposeGroup.UPDATE,
            DefaultStoreExposeGroup.BASE_PATCH,
        ],
    })
], PatchDefaultStoreDto);
export { PatchDefaultStoreDto };
//# sourceMappingURL=PatchDefaultStoreDto.js.map